import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    vendorType: {
        label: ""
    },
    vendorTypeList: [

    ]
}

const vendorType = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default vendorType;